import React from 'react'
import {Link,useNavigate} from 'react-router-dom'
import {UserAuth} from '../context/AuthContext';

/*  This component is the navigation bar of the website.
    Consists of the logo, sign in, sign up, account and 
    logout links along with the Firebase authorization check.*/
const Navbar = () => {
  const {user,logOut} = UserAuth()
  const navigate = useNavigate()
  
// function to log the user out using the 
// logout function from the firebase sdk.
  const handleLogout = async() =>{
    try{
      await logOut();
      navigate('/');
    }catch(error){
      console.log(error);
    }
  }

  return (
    <div className="flex items-center justify-between p-4 z-[100] w-full absolute">
        {/*The logo also serves as a link to the 'home' page*/}
        <Link to='/'>
          {/* H1- Website logo */}
        <h1 className='text-violet-500 text-4xl font-bold cursor-pointer'>Vixie</h1>
        </Link>
      {user?.email ? (<div>
        {/* link to account dashboard*/}
              <Link to ='/account'>
                <button className="text-white pr-4">Account</button>
                </Link>
                
                <button onClick={handleLogout} className='bg-violet-500 px-6 py-2 rounded cursor-pointer text-white'>
                  Logout</button>
               
            </div>) : (<div>
              {/* Link to account page*/}
              <Link to ='/login'>
                <button className="text-white pr-4">Sign In</button>
                </Link>
                {/* Link to sign up page.*/}
                <Link to ="/signup">
                <button className='bg-violet-500 px-6 py-2 rounded cursor-pointer text-white'>Sign Up</button>
                </Link>
            </div>)}       
    </div>

  )
}

export default Navbar